import { Icon } from "@iconify/react/dist/iconify.js";
import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { authLogin } from "../store/slices/auth";
import { useDispatch } from "react-redux";
import logo from "./../assets/images/logo.png";

const Login = () => {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [errors, setErrors] = useState({});
  const [isdisabled, setisDisabled] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    const validationErrors = { ...errors };

    if (name === "password") {
      setPassword(value);
      validationErrors.password =
        value.trim() === "" ? "Please enter your password" : "";
    } else if (name === "username") {
      setUsername(value);
      validationErrors.username =
        value.trim() === "" ? "Please enter your username" : "";
    }

    setErrors(validationErrors); // Ensure state is updated
  };

  const dispatch = useDispatch();
  const navigate = useNavigate("");

  async function signIn(e) {
    e.preventDefault();
    setisDisabled(true);
    setTimeout(() => {
      setisDisabled(false);
    }, 3000);
    const validationErrors = {};
    if (!username.trim()) {
      validationErrors.username = "Please enter your username";
    }

    if (!password.trim()) {
      validationErrors.password = "Please enter your password";
    }

    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    } else {
      let item = {
        username,
        password,
      };

      dispatch(authLogin(item))
        .unwrap()
        .then(() => {
          navigate("/admin/home");
        })
        .catch((err) => {
          let errorMsg = "";

          // Case 1: message exists directly
          if (err?.message) {
            errorMsg = err.message;
          }

          // Case 2: message exists inside error.data (stringified JSON)
          if (err?.error?.data) {
            try {
              const parsed = JSON.parse(err.error.data);
              errorMsg = parsed.msg || errorMsg;
            } catch (e) {
              // fallback if parsing fails
            }
          }

          alert(errorMsg);
        });
    }
  }

  return (
    <section className="auth bg-base d-flex flex-wrap">
      <div className="auth-left d-lg-block d-none">
        <div className="d-flex align-items-center flex-column h-100 justify-content-center">
          <img src={logo} style={{ height: "300px" }} alt="" />
        </div>
      </div>
      <div className="auth-right py-32 px-24 d-flex flex-column justify-content-center">
        <div className="max-w-464-px mx-auto w-100">
          <div>
            <Link to="/" className="mb-40 max-w-290-px">
              <img src="assets/images/logo.png" alt="" />
            </Link>
            <h4 className="mb-12">Sign In to your Account</h4>
            <p className="mb-32 text-secondary-light text-lg">
              Welcome back! please enter your detail
            </p>
          </div>
          <form autoComplete="off" onSubmit={signIn}>
            <div className="position-relative mb-20">
              <div className="icon-field">
                <span className="icon top-50 translate-middle-y">
                  <Icon icon="mage:user" />
                </span>
                <input
                  type="text"
                  name="username"
                  value={username}
                  onChange={handleChange}
                  className={`form-control h-44-px bg-neutral-50 radius-12 ${
                    errors.username ? "is-invalid" : ""
                  }`}
                  placeholder="Enter your username"
                />
              </div>
              {errors.username && (
                <div style={{ color: "red", fontSize: "14px" }}>
                  {errors.username}
                </div>
              )}
            </div>

            <div className="position-relative mb-20">
              <div className="icon-field">
                <span className="icon top-50 translate-middle-y">
                  <Icon icon="solar:lock-password-outline" />
                </span>
                <input
                  type={showPassword ? "text" : "password"}
                  name="password"
                  value={password}
                  onChange={handleChange}
                  className={`form-control h-44-px bg-neutral-50 radius-12 ${
                    errors.password ? "is-invalid" : ""
                  }`}
                  placeholder="Enter password"
                />
                <span
                  className="password-toggle-icon"
                  style={{
                    position: "absolute",
                    right: "15px",
                    top: "50%",
                    transform: "translateY(-50%)",
                    cursor: "pointer",
                    zIndex: 2,
                  }}
                  onClick={() => setShowPassword(!showPassword)}
                >
                  <Icon icon={showPassword ? "mdi:eye-off" : "mdi:eye"} />
                </span>
              </div>
              {errors.password && (
                <div style={{ color: "red", fontSize: "14px" }}>
                  {errors.password}
                </div>
              )}
            </div>

            <div className="">
              <div className="d-flex justify-content-between gap-2">
                <div className="form-check style-check d-flex align-items-center"></div>
                <Link to="#" className="text-primary-600 fw-medium">
                  Forgot Password?
                </Link>
              </div>
            </div>
            <button
              type="submit"
              disabled={isdisabled}
              className="btn btn-primary text-lg btn-sm px-12 py-12 w-100 radius-12 mt-32"
            >
              Sign In
            </button>
          </form>
        </div>
      </div>
    </section>
  );
};

export default Login;
